export default [
  {
    label: '中国', value: '86', pattern: /^1[3|4|5|6|7|8|9]\d{9}$/
  },
  {
    label: '德国', value: '49', pattern: /^1(\d{5,6}|\d{9,12})$/
  },
  {
    label: '日本', value: '81', pattern: /^0{0,1}[7,8,9](?:\d{8}|\d{9})$/
  },
  {
    label: '中国澳门', value: '853', pattern: /^6\d{7}$/
  },
  {
    label: '西班牙', value: '34', pattern: /^\d{6,12}$/
  },
  {
    label: '俄罗斯', value: '7', pattern: /^[13489]\d{9,11}$/
  },
  {
    label: '意大利', value: '39', pattern: /^[37]\d{8,11}$/
  },
  {
    label: '法国', value: '33', pattern: /^(\d{6}|\d{8,10})$/
  },
  {
    label: '美国', value: '1', pattern: /^\d{10,12}$/
  },
  {
    label: '越南', value: '84', pattern: /^[1-9]\d{6,9}$/
  },
  {
    label: '加拿大', value: '1', pattern: /^\d{10}$/
  },
  {
    label: '新加坡', value: '65', pattern: /^[13689]\d{6,7}$/
  },
  {
    label: '泰国', value: '66', pattern: /^[13456789]\d{7,8}$/
  },
  {
    label: '英国', value: '44', pattern: /^[347-9](\d{8,9}|\d{11,12})$/
  },
  {
    label: '韩国', value: '82', pattern: /^0{0,1}[7,1](?:\d{8}|\d{9})$/
  },
  {
    label: '中国台湾', value: '886', pattern: /^0{0,1}[6,7,9](?:\d{7}|\d{8}|\d{10})$/
  },
  {
    label: '新西兰', value: '64', pattern: /^[278]\d{7,9}$/
  },
  {
    label: '澳大利亚', value: '61', pattern: /^4\d{8,9}$/
  },
  {
    label: '菲律宾', value: '63', pattern: /^[24579](\d{7,9}|\d{12})$/
  },
  {
    label: '中国香港', value: '852', pattern: /^0{0,1}[1,4,5,6,9](?:\d{7}|\d{8}|\d{12})$/
  },
  {
    label: '马来西亚', value: '60', pattern: /^1\d{8,9}$/
  },
  {
    label: '马尔代夫', value: '960', pattern: /^\d{6,12}$/
  }
].map(item => {
  return {
    ...item,
    title: `${item.label}+${item.value}`
  }
})
